import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { PlantCode } from "src/model/class/general classes/plant-code";
import { PlantCodeGeneric } from "src/model/class/general classes/plant-code-generic";
import {
  PlantCodesStoreAction,
  PlantsStoreAction,
} from "src/components/shared-components/enum/enumStoreAction";

/**
 * Reset "plant-codes" main features state and unset key storage
 */
export const plantCodesUnsetKeyStorage = createAction(
  PlantCodesStoreAction.PLANT_CODES_UNSET_KEY_STORAGE
);

/**
 * Action fired when request to load start
 */
export const plantCodesLoadInitStartAction = createAction(
  PlantCodesStoreAction.PLANT_CODES_LOAD_INIT_START
);

/**
 * Action to load full plant-codes lists
 */
export const plantCodesLoadListFromApiAction = createAction(
  PlantCodesStoreAction.PLANT_CODES_LOAD_FROM_API
);

//#endregion

//#region "ONLY-PLANT-CODE" IMPLEMENTATION
/**
 * Action plant-codes lists load success
 */
export const plantCodesLoadSuccessAction = createAction(
  PlantCodesStoreAction.PLANT_CODES_LOAD_SUCCESS,
  props<{ plantCodesObject: PlantCode }>()
);

//#endregion

/**
 * Action to handle generic error in plant-codes lists loading from API
 */
export const plantCodesLoadErrorHandlingAction = createAction(
  PlantCodesStoreAction.PLANT_CODES_LOAD_ERROR_HANDLING,
  props<{ error: HttpErrorResponse }>()
);

/**
 * Action plant-codes lists loadinga error
 */
export const plantCodesLoadErrorAction = createAction(
  PlantCodesStoreAction.PLANT_CODES_LOAD_ERROR
);

/**
 * Action to start plant code addresses subscribing
 */
export const plantCodesStartSubscribeAddressAction = createAction(
  PlantCodesStoreAction.PLANT_CODES_SUBSCRIBE_ADDRESS_CHANGE_START,
  props<{ listPlantCodeGeneric: Array<PlantCodeGeneric> }>()
);

/**
 * Action to complete subscribe plant code addresses
 */
export const plantCodesCompleteSubscribeAddressAction = createAction(
  PlantCodesStoreAction.PLANT_CODES_SUBSCRIBE_ADDRESS_CHANGE_COMPLETE
);

/**
 * Action handle update value for specfic plant code
 */
export const plantCodeAddressValueChangeAction = createAction(
  PlantCodesStoreAction.PLANT_CODES_ADDRESS_VALUE_CHANGE,
  props<{ instanceGUID: string; address: string; plantCodeValue: string }>()
);
